<template>
    <div :class="{
            'update-web': true,
            'update-mobile': $detect == 'mobile'
        }">
        <div class="row">
            <div :class="{
                    'col-6 pr-2': $detect == 'web',
                    'col-12 p-0': $detect == 'mobile'
                    }">
                <div class="card-dashboard position-relative">
                    <div class="title-card">
                        <div class="d-flex justify-content-between">
                            <div class="py-10px px-3">Hình ảnh</div>
                            <div class="btn-image-storage" v-if="!(this.form.status == 1 && this.form.status_expire === 0)">
                                <button class="btn btn-primary btn-sm" @click="imgStorage = true">Chọn ảnh từ kho ảnh</button>
                            </div>
                        </div>
                    </div>
                    <div class="body-card-auto">
                        <div class="info-picture vg-scrollbar px-2">
                            <div :class="{
                                    'd-flex flex-wrap pb-35px' : $detect == 'web',
                                    'd-flex flex-nowrap pt-3 pb-25px img-flex' : $detect == 'mobile'
                                }">
                                <div class="upload-img text-center">
                                    <div class="btn-upload" role="button" @click="upload()">
                                        <i class="icon ion-md-cloud-upload"></i>
                                        <p class="mb-0 fs-14px">
                                            Tải ảnh lên
                                        </p>
                                    </div>
                                </div>
                                <input type="file" v-show="false" multiple class="input-upload" @change="changeImage"/>
                                <div class="img position-relative" role="button" v-for="(item) in previewImg" :key="item.id">
                                    <img class="w-100 h-100" :src="item.url"/>
                                    <div class="loading-img position-absolute d-flex justify-content-center align-items-center">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="img position-relative" role="button" v-for="(item, index) in form.pictures" :key="index">
                                    <img class="w-100 h-100" :src="item.url" @click="form.pictures.length > 1 ? selectPictureMain(item) : ''"/>
                                    <div class="delete-img position-absolute" @click="destroy(item, index)" v-if="form.pictures.length > 1">
                                        <i class="icon ion-ios-close"></i>
                                    </div>
                                    <div class="checked-img position-absolute text-center" v-if="item.name == form.picture_main">
                                        <div class="btn-check text-center">
                                            <i class="icon ion-md-checkmark mr-1 fs-12px"></i>
                                            <span class="fs-12px">Ảnh chính</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :class="{
                            'fs-12px position-absolute text-noti-image w-100': true,
                            'text-noti-image-mobile': $detect == 'mobile'
                        }">
                        * Click vào ảnh để thay đổi ảnh chính
                    </div>
                </div>
            </div>
            <div :class="{
                    'col-6 pl-2': $detect == 'web',
                    'col-12 p-0': $detect == 'mobile'
                    }">
                <div class="card-dashboard">
                    <div class="title-card">
                        <div class="d-flex justify-content-between">
                            <div class="py-10px px-3">Thông tin</div>
                            <div class="btn-update" role="button" @click="updateCheck = 1" v-if="!(this.form.status == 1 && this.form.status_expire === 0)">
                                <i class="icon ion-md-create mr-2"></i>Chỉnh sửa
                            </div>
                        </div>
                    </div>
                    <div class="body-card-auto">
                        <div class="info-post p-3 fs-14px">
                            <div class="d-flex">
                                <div class="w-title">Danh mục:</div>
                                <div class="w-value"><p class="mb-0 name-category">{{form.category ? form.category.name : ''}}</p></div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Tiêu đề:</div>
                                <div class="w-value"><p class="mb-0 title-post">{{form.name}}</p></div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Giá:</div>
                                <div class="w-value fw-600 text-danger">{{form.price}} vnđ</div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Địa chỉ:</div>
                                <div class="w-value">{{form.poster_address}}</div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Tỉnh thành:</div>
                                <div class="w-value">
                                    {{form.city ? form.city.name : ''}}
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Hình thức:</div>
                                <div class="w-value">
                                    {{form.type == 0 ? 'Cần bán' : 'Cần mua'}}
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Trạng thái:</div>
                                <div class="w-value">
                                    {{form.new_old == 0 ? 'Hàng mới' : 'Hàng cũ'}}
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Người đăng:</div>
                                <div class="w-value">{{form.poster_name}}</div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Điện thoại:</div>
                                <div class="w-value">{{form.poster_phone}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="update-info mt-3">
            <div class="card-dashboard">
                <div class="title-card">
                    <div class="d-flex justify-content-between">
                        <div class="py-10px px-3">Nội dung</div>
                        <div class="btn-update" role="button" @click="updateCheck = 2" v-if="!(this.form.status == 1 && this.form.status_expire === 0)">
                            <i class="icon ion-md-create mr-2"></i>Chỉnh sửa
                        </div>
                    </div>
                </div>
                <div class="body-card-auto p-3">
                    <div class="input-content">
                        <p :class="{
                            'mb-0 fs-14px': true,
                            'see-more-content': seeMore === 1,
                            }" id="content-description" v-html="form.description"></p>
                        <div class="line-text" v-if="seeMore !== 0" @click="btnMore()">
                            <span role="button">{{seeMore === 1 ? 'Xem thêm' : 'Thu gọn'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <updateInfo v-show="updateCheck == 1"
            :active.sync="updateCheck"
            :data="form"
            @dataEmit="emitInfo($event)"/>
        <updateContent v-show="updateCheck == 2"
            :active.sync="updateCheck"
            :data="form"
            @dataEmit="emitTitel($event)"/>
        <!-- <updatePicture v-show="updateCheck == 3"
            :data="form"
            :active.sync="updateCheck"/> -->
        <ldc-dialog
            title="Kho ảnh"
            :clickoutside="true"
            colorTitle="#007bff"
            width="50%"
            :fullscreen="$detect == 'mobile' ? true : false"
            :visible.sync="imgStorage"
            class="img-storage">
            <div class="my-img vg-scrollbar">
                <div class="d-flex flex-wrap px-2 pb-3">
                    <div class="img position-relative" role="button" v-for="(item, index) in images" :key="index"
                        @click="selectImage(item)">
                        <img class="w-100 h-100" :src="item.image_thum"/>
                        <div class="checked-img position-absolute" v-if="idImageSelect.includes(item.id)">
                            <div class="btn-check">
                                <i class="icon ion-ios-checkmark"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dots-loading mb-3" v-if="loadingImage">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div class="btn-loadmore-img text-center mb-3" v-if="!loadingImage && next_page">
                    <button class="btn btn-outline-primary btn-sm" @click="getDataImage(next_page)">Tải thêm ảnh</button>
                </div>
            </div>
            <div class="footer-dialog border-top border-primary text-center p-10px">
                <button class="btn btn-primary btn-sm" @click="updateSelect()">Chọn ảnh</button>
            </div>
        </ldc-dialog>
    </div>
</template>
<script>
import { getToken } from '@/config/token';
import { pictureProductThumb } from '@/config/function';
export default {
    props: ['data'],
    components: {
        updateInfo: () => import('./updateInfo'),
        // updatePicture: () => import('./updatePicture'),
        updateContent: () => import('./updateContent'),
    },
    data(){
        return {
            updateCheck: 0,
            form: {},
            seeMore: 0,
            previewImg: [],
            id: this.$route.params.id,
            imgStorage: false,

            next_page: 0,
            loadingImage: false,
            max_id: null,
            images: [],
            imageSelect: [],
            idImageSelect: [],
        }
    },
    watch: {
        data: {
            handler(val){
                this.form = val;
            },
            deep: true,
        },
    },
    created() {
        this.form = this.data;
        this.sortImg();
        this.getDataImage(1);
    },
    updated() {
        setTimeout(() => {
            let content = document.getElementById("content-description");
            if(content) {
                if(content.offsetHeight > 250 && this.seeMore !== 2) {
                    this.seeMore = 1;
                }
            }
        }, 100)
    },
    methods: {
        /**Ảnh kho */
        getDataImage(page) {
            this.loadingImage = true;
            apiGet('/v2/profile/user_gallery', {
                page: page,
                max_id: this.max_id,
            }).then(res => {
                let data = res.data;
                data.data.map(item => {
                    this.images.push(item);
                });
                this.next_page = data.next_page;
                if(page == 1){
                    this.max_id = data.data[0].id;
                }
                this.loadingImage =false;
            }).catch(err => {
                this.loadingImage = false;
            })
        },
        selectImage(image){
            if(this.idImageSelect.includes(image.id)){
                this.idImageSelect.map((item, index) => {
                    if(item == image.id){
                        this.idImageSelect.splice(index, 1);
                    }
                })
                this.imageSelect.map((item, index) => {
                    if(item.id == image.id){
                        this.imageSelect.splice(index, 1);
                    }
                })
            }else{
                this.idImageSelect.push(image.id);
                this.imageSelect.push(image);
            }
        },
        async updateSelect(){
            if(this.imageSelect.length == 0) return;
            let data = [];
            this.imageSelect.map(item => {
                data.unshift({
                    id: item.id,
                    name: item.filename,
                    width: item.width,
                    height: item.height
                })
            });
            this.form.pictures.map(item => {
                data.push({
                    id: item.id,
                    name: item.name,
                    width: item.width,
                    height: item.height,
                });
            })
            await apiPut(`/v2/profile/raovat/${this.id}`, {
                data_gallery: data,
            }).then(res => {
                if(res.success == 1){
                    let picture = [];
                    this.imageSelect = [];
                    this.idImageSelect = [];
                    res.data.gallery.map(item => {
                        picture.push({
                            height: item.height,
                            id: item.id,
                            name: item.name,
                            url: item.link.medium,
                            width: item.width
                        })
                    })
                    this.form.pictures = picture;
                    this.form.picture_main = res.data.picture_name;
                    this.imgStorage = false;
                    this.sortImg();
                    this.$message({
                        message: 'Cập nhập ảnh thành công',
                        type: 'success',
                        center: true,
                    })
                }else{
                    this.$message({
                        message: res.message,
                        type: 'error',
                        center: true,
                    })
                }
            }).catch(err => {
                this.$message({
                    message: 'Lỗi hệ thống',
                    type: 'error',
                    center: true,
                })
            })
        },
        /**Hết ảnh kho */
        sortImg(){
            if(!this.form.pictures) return;
            let img = [];
            this.form.pictures.map(item => {
                if(item.name === this.form.picture_main){
                    img.unshift(item);
                }else{
                    img.push(item);
                }
            })
            this.form.pictures = img;
        },
        emitInfo(e){
            this.form = {
                category: e.category,
                poster_address: e.poster_address,
                city: e.city,
                price: this.$formatNumber(e.price),
                type: e.type,
                new_old: e.new_old,
                poster_name: e.poster_name,
                poster_phone: e.poster_phone,
                pictures: this.form.pictures,
                description: this.form.description,
                name: e.name,
                status: e.status,
                post_date: this.form.post_date,
                picture_main: this.form.picture_main,
            }
        },
        emitTitel(e){
            this.form = {
                category: this.form.category,
                poster_address: this.form.poster_address,
                city: this.form.city,
                price: this.$formatNumber(this.form.price),
                type: this.form.type,
                new_old: this.form.new_old,
                poster_name: this.form.poster_name,
                poster_phone: this.form.poster_phone,
                pictures: this.form.pictures,
                description: e.description,
                name: this.form.name,
                status: e.status,
                post_date: this.form.post_date,
                picture_main: this.form.picture_main,
            }
        },
        btnMore() {
            if(this.seeMore === 1){
                this.seeMore = 2;
            }else{
                this.seeMore = 1;
            }
        },
        upload(){
            if(this.form.status == 1 && this.form.status_expire === 0){
                this.message();
                return;
            }
            let input = this.$el.querySelector('.input-upload');
            input.click();
        },
        message(){
            this.$message({
                message: 'Vui lòng gian hạn tin',
                type: 'warning',
                center: true,
            })
        },
        changeImage(e){
            let files = e.target.files;
            let id = 10000;
            for(let item of files){
                item.url = URL.createObjectURL(item);
                item.id = id;
                this.previewImg.unshift(item);
                id++;
            }
            this.pushImage();
        },
        destroyPreview(item, index){
            this.files.splice(index, 1);
        },
        destroy(image, index){
            let target = this;
            this.$confirm('Bạn có chắc chắn xóa ảnh này khỏi tin?', 'Xóa ảnh', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'error'
            }).then(res => {
                let data = [];
                target.loadingDestroy = true;
                target.form.pictures.map(item => {
                    if(image.id != item.id){
                        data.push({
                            id: item.id,
                            name: item.name,
                            width: item.width,
                            height: item.height,
                        });
                    }
                });
                let picture1 = '';
                if(image.name != target.form.picture_main){
                    picture1 = target.form.picture_main;
                }else{
                    target.form.pictures.map(item => {
                        if(picture1 === '' && item.name != image.name){
                            picture1 = item.name;
                        }
                    })
                }
                apiPut(`/v2/profile/raovat/${target.id}`, {
                    data_gallery: data,
                    picture1: picture1,
                }).then(res => {
                    target.loadingDestroy = false;
                    if(res.success == 1){
                        target.$message({
                            message: 'Xóa ảnh thành công',
                            type: 'success',
                            center: true,
                        })
                        target.form.pictures.splice(index, 1)
                        target.form.picture_main = picture1;
                        this.sortImg();
                    }else{
                        target.$message({
                            message: 'Lỗi hệ thống, Vui lòng thử lại sau',
                            type: 'error',
                            center: true,
                        })
                    }
                }).catch(err => {target.loadingDestroy = false})
            })
        },
        async pushImage(){
            let form;
            let dataPutImage = [];
            for(let item of this.previewImg){
                if(item.type == 'image/jpeg' || item.type == 'image/png' || item.type == 'image/jpg'){
                    form = new FormData();
                    form.append('files', item);
                    await apiPost(`https://cdnvg.scandict.com/upload.php`, form).then(async res => {
                        let data = res[0];
                        if(data.success == 1){
                            dataPutImage.unshift(data)
                        }else{
                            this.$message({
                                message: `Upload ảnh ${item.name} bị lỗi`,
                                type: 'error',
                                center: true,
                            })
                        }
                    }).catch(err => {
                        this.$message({
                            type: 'error',
                            message: 'Lỗi hệ thống',
                            center: true,
                        });
                    })
                }
            }
            await this.update(dataPutImage);
            this.previewImg = [];
        },
        async update(image){
            if(image.length == 0) return;
            let data = [];
            image.map(item => {
                data.unshift({
                    name: item.filename,
                    width: item.width,
                    height: item.height
                })
            });
            this.form.pictures.map(item => {
                data.push({
                    id: item.id,
                    name: item.name,
                    width: item.width,
                    height: item.height,
                });
            })
            await apiPut(`/v2/profile/raovat/${this.id}`, {
                data_gallery: data,
            }).then(res => {
                if(res.success == 1){
                    let picture = [];
                    res.data.gallery.map(item => {
                        picture.push({
                            height: item.height,
                            id: item.id,
                            name: item.name,
                            url: item.link.medium,
                            width: item.width
                        })
                    })
                    this.form.pictures = picture;
                    this.form.picture_main = res.data.picture_name;
                    this.sortImg();
                    this.$message({
                        message: 'Thêm mới ảnh thành công',
                        type: 'success',
                        center: true,
                    })
                }else{
                    this.$message({
                        message: res.message,
                        type: 'error',
                        center: true,
                    })
                }
            }).catch(err => {
                this.$message({
                    message: 'Lỗi hệ thống',
                    type: 'error',
                    center: true,
                })
            })
        },
        destroyPreview(id){
            this.previewImg.map((item, index) => {
                if(item.id === id){
                    this.previewImg.splice(index, 1);
                }
            })
        },
        async selectPictureMain(image){
            this.$confirm('Bạn có chắc chắn sử dụng ảnh này làm ảnh chính cho tin này không?', 'Thay đổi ảnh đại diện', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'success'
            }).then(async () => {
                this.loadingDestroy = true;
                await apiPut(`/v2/profile/raovat/${this.id}`, {
                    picture1: image.name,
                }).then(res => {
                    if(res.success == 1){
                        this.form.picture_main = res.data.picture_name;
                        this.sortImg();
                    }else{
                        this.$message({
                            message: res.message,
                            type: 'error',
                            center: true,
                        })
                    }
                }).catch(err => {})
                this.loadingDestroy = false;
            }).catch(() => {});
        }
    },
}
</script>
<style lang="scss">
    .update-web {
        .card-dashboard {
            box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
            background: #fff;
            border-radius: 5px;
            .title-card {
                border-bottom: 1px solid #0c81f6;
                .btn-update {
                    color:#007bff;
                    font-size: 14px;
                    padding: 11px 16px;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
            .body-card-auto {
                .info-post {
                    .w-title {
                        width: 150px;
                        color: #666;
                    }
                    .w-value {
                        width: calc( 100% - 150px );
                    }
                }
                .title-post {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .info-picture {
                    height: 380px;
                    overflow: auto;
                    .img {
                        width: 20%;
                        height: 110px;
                        padding: 16px 8px 0;
                        &:hover {
                            .delete-img {
                                display: block !important;
                            }
                        }
                        img {
                            box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);
                            object-fit: cover;
                            border-radius: 4px;
                        }
                        .delete-img {
                            background: rgba(189, 195, 199,0.8);
                            top: 16px;
                            right: 8px;
                            width: 20px;
                            height: 20px;
                            line-height: 20px;
                            text-align: center;
                            border-radius: 0 4px 0 0;
                            display: none;
                            i {
                                font-size: 20px;
                                color: #fff;
                            }
                        }
                    }
                    .upload-img {
                        width: 20%;
                        height: 110px;
                        padding: 16px 8px 0;
                        .btn-upload {
                            border-radius: 4px;
                            border: 2px dashed rgba(0,0,0,0.2);
                            height: 100%;
                            padding: 10px 0px;
                            i {
                                font-size: 30px;
                                color: #666;
                            }
                            p {
                                color: #666;
                            }
                        }
                    }
                    .checked-img {
                        bottom: 0;
                        width: calc(100% - 16px);
                        background: rgba(40, 167, 69, 0.8);
                        border-radius: 0 0 4px 4px;
                        .btn-check {
                            color: #fff;
                        }
                    }
                    .loading-img {
                        top: 16px;
                        width: 119px;
                        height: 100px;
                        background: rgba(255, 255, 255, 0.8);
                        left: 0;
                    }
                }
                .info-post {
                    height: 380px;
                    overflow: auto;
                }
                .name-category {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
        .noti-picture {
            padding: 11px 16px;
        }
        .text-noti-image {
            bottom: 0;
            color: #999;
            font-style: italic;
            background: #fff;
            text-align: right;
            padding: 3px 10px;
            border-top: 1px solid rgba(0, 0, 0, 0.2);
        }
        .text-noti-image-mobile {
            border-top: none !important;
        }
        .btn-image-storage {
            padding: 7px 10px;
        }
        .see-more-content {
            max-height: 250px;
            overflow: hidden;
        }
        .line-text {
            text-align: center;
            position: relative;
        }

        .line-text:before {
            content: "";
            width: 100%;
            height: 1px;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            background-color: #ccc;
        }

        .line-text span {
            display: inline-block;
            background-color: white;
            position: relative;
            padding: 1rem;
            font-weight: 600;
        }
        .action-detail {
            .btn-action-update {
                width: 150px;
            }
        }
        .img-storage {
            .my-img {
                height: 400px;
                overflow: auto;
                .img {
                    width: 20%;
                    height: 140px;
                    padding: 16px 8px 0;
                    &:hover {
                        .delete-img {
                            display: block !important;
                        }
                    }
                    img {
                        box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);
                        object-fit: cover;
                        border-radius: 4px;
                    }
                    .delete-img {
                        background: rgba(189, 195, 199,0.8);
                        top: 16px;
                        right: 8px;
                        width: 25px;
                        height: 25px;
                        line-height: 25px;
                        text-align: center;
                        border-radius: 0 4px 0 0;
                        display: none;
                        i {
                            font-size: 20px;
                            color: #fff;
                        }
                    }
                }
                .checked-img {
                    bottom: 0;
                    right: 8px;
                    color: #fff;
                    border-radius: 0 0 4px 0;
                    overflow: hidden;
                    .btn-check {
                        width: 0;
                        height: 0;
                        border-bottom: 28px solid #28a745;
                        border-left: 28px solid transparent;
                        i {
                            margin-left: -14px;
                            font-size: 25px;
                        }
                    }
                }
            }
            .ldc-dialog-content {
                padding: 0 !important;
                .title-dialog {
                    font-size: 16px !important;
                    padding: 10px !important;
                    margin: 0 !important;
                    border-bottom: 1px solid #007bff;
                }
            }
            .footer-dialog {
                z-index: 4000;
                button {
                    width: 120px;
                }
                .btn-outline-primary {
                    &:hover {
                        background: #fff !important;
                        color: #007bff !important;
                    }
                }
            }
            .btn-loadmore-img {
                button {
                    width: 200px;
                    &:hover {
                        background: #fff !important;
                        color: #007bff !important;
                    }
                }
            }
            .dots-loading {
                display: flex;
                justify-content: center;
            }
            .dots-loading > div {
                width: 10px;
                height: 10px;
                border-radius: 10px;
                background-color: #ccc;
                margin: 0 10px;
                animation: dotLoading 1s forwards infinite linear;
            }
            .dots-loading > div:nth-child(2) {
                animation-delay: 0.1s;
            }
            .dots-loading > div:nth-child(3) {
                animation-delay: 0.2s;
            }
            .dots-loading > div:nth-child(4) {
                animation-delay: 0.3s;
            }
            @keyframes dotLoading {
                to {
                    opacity: 0;
                }
            }
        }
    }
    .update-mobile {
        overflow: hidden !important;
        .row {
            margin: 0 !important;
        }
        .info-picture {
            height: unset !important;
            .img {
                width: 100px !important;
                padding: 0 !important;
                height: 100px !important;
                margin: 0 8px;
                img {
                    width: 100px !important;
                    height: 100px !important;
                }
                .delete-img {
                    display: block !important;
                    top: 0 !important;
                    right: 0 !important;
                }
            }
            .img-flex {
                overflow-y: hidden;
                overflow-x: auto;
            }
            .upload-img {
                width: 100px !important;
                height: 100px !important;
                padding: 0 !important;
                margin: 0 8px;
                .btn-upload {
                    width: 100px !important;
                    height: 100px !important;
                }
            }
            .checked-img {
                width: 100% !important;
            }
        }
        .info-post {
            height: unset !important;
            .w-title {
                width: 100px !important;
            }
            .w-value {
                width: calc( 100% - 100px ) !important;
            }
        }
        .loading-img {
            top: 0 !important;
            left: 0;
            width: 100px !important;
        }
        .update-info {
            margin-top: 0 !important;
        }
        .card-dashboard {
            box-shadow: none;
            .title-card {
                border-top: 1px solid #0c81f6;
            }
        }
        .img-storage {
            .ldc-dialog-content {
                overflow: auto;
                .my-img {
                    height: unset !important;
                    margin-bottom: 61px;
                }
            }
            .title-dialog {
                top: 0 !important;
                z-index: 1;
                background: #007bff;
                color: #fff !important;
                text-align: center;
            }
            .close-modal-mobile {
                position: absolute;
                top: 0;
                z-index: 1;
                padding-top: 5px;
                i {
                    color: #fff;
                    font-size: 22px;
                    padding: 15px;
                }
            }
            .footer-dialog {
                position: fixed;
                bottom: 0 !important;
                width: 100%;
                left: 0 !important;
                background: #fff;
                button {
                    height: 40px;
                    width: 200px !important;
                }
            }
            .img {
                width: 33.33333333333333% !important;
                padding: 16px 8 0 !important;
                height: 100px !important;
                img {
                    width: 100% !important;
                    height: 100% !important;
                }
                .delete-img {
                    display: block !important;
                    top: 16px !important;
                    right: 8px !important;
                }
            }
        }
    }
    .input-content {
        img {
            max-width: 100% !important;
        }
    }
</style>
